var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDoNotDisturb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82 82",
    style: {
      enableBackground: "new 0 0 82 82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1,959c2.4-2.4,5.1-4.5,7.8-6.3c0.9-0.6,2.2-0.3,2.8,0.6c0.4,0.7,0.4,1.5,0,2.1c-9.8,15.6-8,36.3,5.4,49.7 c13.5,13.5,34.2,15.2,49.7,5.4c0.9-0.6,2.2-0.3,2.8,0.6c0.4,0.7,0.4,1.5,0,2.1c-1.8,2.8-3.8,5.4-6.3,7.8 c-17.3,17.3-45.4,17.5-62.6,0.3C-4.4,1004.3-4.2,976.3,13.1,959L13.1,959z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoNotDisturb);
export default __webpack_public_path__ + "static/media/ic_do_not_disturb.95c0782dde8ef7987dd6713eee877423.svg";
export { ForwardRef as ReactComponent };